import { render, staticRenderFns } from "./monthRecord.vue?vue&type=template&id=38991362"
import script from "./monthRecord.vue?vue&type=script&lang=js"
export * from "./monthRecord.vue?vue&type=script&lang=js"
import style0 from "./monthRecord.vue?vue&type=style&index=0&id=38991362&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports